// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Tool     : bondc, Version=3.0.1, Build=bond-git.debug.not
//     Template : Microsoft.Bond.Rules.dll#TypeScript.tt
//     File     : bond-const.ts
//
//     Changes to this file may cause incorrect behavior and will be lost when
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum BondDataType {
  BT_STOP = 0,
  BT_STOP_BASE = 1,
  BT_BOOL = 2,
  BT_UINT8 = 3,
  BT_UINT16 = 4,
  BT_UINT32 = 5,
  BT_UINT64 = 6,
  BT_FLOAT = 7,
  BT_DOUBLE = 8,
  BT_STRING = 9,
  BT_STRUCT = 10,
  BT_LIST = 11,
  BT_SET = 12,
  BT_MAP = 13,
  BT_INT8 = 14,
  BT_INT16 = 15,
  BT_INT32 = 16,
  BT_INT64 = 17,
  BT_WSTRING = 18,
  BT_UNAVAILABLE = 127
}

export enum ProtocolType {
  MARSHALED_PROTOCOL = 0,
  MAFIA_PROTOCOL = 17997,
  COMPACT_PROTOCOL = 16963,
  JSON_PROTOCOL = 21322,
  PRETTY_JSON_PROTOCOL = 20554,
  SIMPLE_PROTOCOL = 20563
}
